import { ClassCreatedModalTranslations } from "./types";

export const deTranslations: ClassCreatedModalTranslations = {
    title: "Die Session wurde erstellt.",
    subtitle: "Geben Sie diese Session-ID an Ihre Studierenden weiter.",
    copyConfirmation: "Kopiert!"
};